import {
  MonthlyPlanSchedule,
  MonthlyPlanScheduleSummary,
  PlanMonthlyScheduleAction as Action,
  PlanMonthlyScheduleActionTypes as ActionTypes,
  SearchParameter,
  MonthlyTargetPlanSchedule,
} from './types';

/**
 * @summary 初期化処理
 * @returns {Action}
 */
export const init = (): Action => ({ type: ActionTypes.INIT });

/**
 * @summary リフレッシュ処理
 * @returns {Action}
 */
export const refresh = (): Action => ({ type: ActionTypes.REFRESH });

/**
 * @summary Loading状態を保持
 * @param {boolean} isLoading
 * @returns {Action}
 */
export const setIsLoading = (isLoading: boolean): Action => ({
  type: ActionTypes.LOADING,
  payload: isLoading,
});

/**
 * @summary 月次スケジュールを個別取得処理を実行中かを保持
 * @param {boolean} isTargetPlanLoading
 * @returns {Action}
 */
export const setIsTargetPlanLoading = (isTargetPlanLoading: boolean): Action => ({
  type: ActionTypes.TARGET_PLAN_LOADING,
  payload: isTargetPlanLoading,
});

/**
 * @summary 送信処理中かを保持
 * @param {boolean} isSubmitting
 * @returns {Action}
 */
export const setIsSubmitting = (isSubmitting: boolean): Action => ({
  type: ActionTypes.SUBMITTING,
  payload: isSubmitting,
});

/**
 * @summary ソート番号を保持
 * @param {number} sort
 * @returns {Action}
 */
export const setSort = (sort: number): Action => ({
  type: ActionTypes.SET_SORT,
  payload: sort,
});

/**
 * @summary 詳細検索条件を保持
 * @param {SearchParameter} searchParameter
 * @returns {Action}
 */
export const setSearchParameter = (searchParameter: SearchParameter): Action => ({
  type: ActionTypes.SET_SEARCH_PARAMETER,
  payload: searchParameter,
});

/**
 * @summary 月次計画リストを保持
 * @param {MonthlyPlanSchedule[]} plans
 * @returns {Action}
 */
export const setPlans = (plans: MonthlyPlanSchedule[]): Action => ({
  type: ActionTypes.SET_PLANS,
  payload: plans,
});

/**
 * @summary 月次計画サマリを保持
 * @param {MonthlyPlanScheduleSummary | null} summary
 * @returns {Action}
 */
export const setSummary = (summary: MonthlyPlanScheduleSummary | null): Action => ({
  type: ActionTypes.SET_SUMMARY,
  payload: summary,
});

/**
 * @summary 月次計画祝日リストを保持
 * @param {number[] | null} holidays
 * @returns {Action}
 */
export const setHolidays = (holidays: number[]): Action => ({
  type: ActionTypes.SET_HOLIDAYS,
  payload: holidays,
});

/**
 * @summary 月次個別計画を保持
 * @param {MonthlyTargetPlanSchedule | null} plan
 * @returns {Action}
 */
export const setTargetPlan = (plan: MonthlyTargetPlanSchedule | null): Action => ({
  type: ActionTypes.SET_TARGET_PLAN,
  payload: plan,
});

/**
 * @summary 選択を確定した契約を保持
 * @param {{ id: number; name: string } | null} contract
 * @returns {Action}
 */
export const setContract = (contract: { id: number; name: string } | null): Action => ({
  type: ActionTypes.SET_CONTRACT,
  payload: contract,
});
